module.exports = __webpack_public_path__ + "static/media/supplier-&-user-management.86f4f739.svg";